module.exports = __webpack_public_path__ + "static/img/3.2b6e0a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R290/3.jpg
// module id = F/Yw
// module chunks = 1